import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Typography,
    IconButton,
    Switch,
    Divider,
    Tooltip,
    Slider
} from '@material-ui/core';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import { HexColorPicker } from "react-colorful";
import { Box } from '@mui/material';

export default function ReportCaptureEditor(props) {
    const [reportCaptureAreaInfoOpen, setReportCaptureAreaInfoOpen] = React.useState(false);
    const [currReportCapture, setCurrReportCapture] = React.useState([]);
    const [currIndex, setCurrIndex] = React.useState(0);
    const [color, setColor] = React.useState("#ADD8E6");
    const ICON_SIZE = 24;

    useEffect(() => {
        if (currReportCapture) {
            setColor(currReportCapture.color || "#ADD8E6");
        }
    }, [currReportCapture]);

    const handleInfoOpen = (index) => {
        setCurrReportCapture(props.reportCaptureAreas[index]);
        setCurrIndex(index);
        setReportCaptureAreaInfoOpen(true);
    };

    const handleChangeReportCapture = (e) => {
        const { name, value } = e.target;
        setCurrReportCapture(prev => ({ ...prev, [name]: value }));
    };

    const handleChangeOpacity = (event, newValue) => {
        console.log("Opacity", newValue);
        setCurrReportCapture((prev) => ({ ...prev, opacity: newValue }));
    };

    const toggleNameVisibility = () => {
        setCurrReportCapture((prevReportCapture) => ({
            ...prevReportCapture,
            visible: !prevReportCapture.visible,
        }));
    };

    const handleColor = (e) => {
        setColor(e);
        setCurrReportCapture(prev => ({ ...prev, color: e }));
    };

    const handleSave = () => {
        if (currReportCapture) {
            const temp = props.reportCaptureAreas;
            console.log("temp", temp);
            console.log("currReportCapture", currReportCapture);
            temp[currIndex] = currReportCapture;
            props.setReportCaptureAreas(temp);
        }
        console.log("Save", currReportCapture);
        setReportCaptureAreaInfoOpen(false);
    };

    return (
        <>
            <Dialog open={reportCaptureAreaInfoOpen} onClose={() => setReportCaptureAreaInfoOpen(false)}>
                <DialogTitle>Report Capture Area Setting</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Name"
                        value={currReportCapture?.name}
                        onChange={handleChangeReportCapture}
                        variant="outlined"
                        name="name"
                        style={{ margin: "10px" }}
                    />
                    <Box display="flex" alignItems="center" gap={2}>
                        <Typography>Show Name</Typography>
                        <Switch
                            onChange={toggleNameVisibility}
                            checked={!currReportCapture?.visible}
                            name="showName"
                            color="primary"
                        />

                    </Box>
                    <TextField
                        label="Opacity"
                        value={currReportCapture?.opacity}
                        variant="outlined"
                        name="opacity"
                        style={{ margin: "10px", display: "none" }}
                    />
                    <Typography gutterBottom>Opacity</Typography>
                    <Slider
                        value={currReportCapture?.opacity || 0.5} // Default to 0.5 if undefined
                        onChange={handleChangeOpacity}
                        step={0.1}
                        min={0.1}
                        max={1}
                        marks
                        valueLabelDisplay="auto"
                        sx={{
                            margin: "10px",
                            width: "90%",
                            color: "#1976d2",
                            '& .MuiSlider-thumb': {
                                width: 20,
                                height: 20,
                            },
                            '& .MuiSlider-rail': {
                                height: 8,
                            },
                            '& .MuiSlider-track': {
                                height: 8,
                            },
                        }}
                    />


                    <HexColorPicker color={color} onChange={handleColor} />
                    Selected Color: {color}

                </DialogContent>
                <div style={{ textAlign: "right", margin: 10 }}>
                    <Button
                        onClick={handleSave}
                        color={"primary"}
                        style={{ margin: "10px" }}
                        variant="contained"
                    >
                        Save
                    </Button>
                    <Button
                        onClick={() => setReportCaptureAreaInfoOpen(false)}
                        color={"primary"}
                        style={{ margin: "10px" }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                </div>
            </Dialog>

            <Box sx={{ maxHeight: "500px", overflowY: "auto", width: "100%" }}>
                <List
                    style={{
                        background: "#f9f9f9",
                        padding: "10px",
                        borderRadius: "8px",
                    }}
                >
                    {props.reportCaptureAreas
                        .sort((a, b) => a.layer - b.layer)
                        .map((reportCapture, index) => (
                            <ListItem
                                style={{
                                    background: "#fff",
                                    border: reportCapture.selected
                                        ? "2px solid darkturquoise"
                                        : "1px solid #ccc",
                                    marginBottom: "8px",
                                    borderRadius: "4px",
                                    boxShadow: "none",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                onClick={() => props.selectReportCaptureArea(reportCapture.id)}
                            >
                                <ListItemText
                                    primary={
                                        <Tooltip title={reportCapture.name}>
                                            <Typography
                                                noWrap
                                                sx={{
                                                    maxWidth: "150px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "block"
                                                }}
                                            >
                                                {reportCapture.name.length > 15 ? reportCapture.name.slice(0, 14) + "…" : reportCapture.name}
                                            </Typography>
                                        </Tooltip>
                                    }
                                    style={{ userSelect: 'none' }}
                                />
                                <ListItemSecondaryAction style={{ display: "flex", alignItems: "center" }}>
                                    <IconButton
                                        onClick={() => handleInfoOpen(index)}
                                        style={{ padding: 4 }}
                                    >
                                        <SettingsIcon style={{ fontSize: ICON_SIZE }} />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => props.lockReportCaptureArea(reportCapture.id)}
                                        style={{ padding: 4 }}
                                    >
                                        {reportCapture.locked
                                            ? <LockIcon style={{ fontSize: ICON_SIZE }} />
                                            : <LockOpenIcon style={{ fontSize: ICON_SIZE }} />}
                                    </IconButton>
                                    <IconButton
                                        onClick={() => props.deleteReportCaptureArea(reportCapture.id)}
                                        style={{ padding: 4 }}
                                    >
                                        <DeleteIcon style={{ fontSize: ICON_SIZE }} />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                </List>
            </Box>
        </>
    );
}
